
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topclinicaltrials",
      function () {
        return require("private-next-pages/topclinicaltrials/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topclinicaltrials"])
      });
    }
  